// src/store/slices/companySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompanyState {
  companyLogo: string;
  logowidthPrint: number;
  companyName: string;
}

const initialState: CompanyState = {
  companyLogo: '',
  logowidthPrint: 15,
  companyName: ''
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyInfo(state, action: PayloadAction<CompanyState>) {
      state.companyLogo = action.payload.companyLogo;
      state.logowidthPrint = action.payload.logowidthPrint;
      state.companyName = action.payload.companyName;
    },
    resetCompanyInfo(state) {
      state.companyLogo = '';
      state.logowidthPrint = 15;
      state.companyName = 'Durham Convention Center';
    }
  }
});

export const { setCompanyInfo, resetCompanyInfo } = companySlice.actions;
export const companyReducer = companySlice.reducer;
